import { render, staticRenderFns } from "./addData_1.vue?vue&type=template&id=fde71e3c&scoped=true"
import script from "./addData_1.vue?vue&type=script&lang=js"
export * from "./addData_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde71e3c",
  null
  
)

export default component.exports